import React from 'react'
import styled from 'styled-components'
import { DEFAULT_CONFIG } from '../../constants/styledComponents'
import { getTypographyDefaultConfig } from '../../utils/typography.util'

const StyledH4 = styled.h4.withConfig(DEFAULT_CONFIG)(props => ({
    ...getTypographyDefaultConfig(props),
    fontSize: 15,
}))

const H4 = props => (
    <StyledH4
        {...props}
        style={
            props.onClick ? { cursor: 'pointer', ...props.style } : props.style
        }
    >
        {props.children}
    </StyledH4>
)

export default H4
